<script setup>
  import {computed} from "vue";

  import {MedTooltip} from "@pharma4u/medicheck-components";
  import {sumBy} from "es-toolkit";

  defineOptions({name: "ComponentRiskCircle"});

  const props = defineProps({
    medication: {
      type: Object,
      required: true,
    },
  });

  const emit = defineEmits(["open:riskScore"]);

  const mostRiskColor = computed(() => {
    if (!props.medication.statistic || props.medication.statistic.length === 0) return "dontShowButton";
    if (
      props.medication.statistic &&
      props.medication.statistic.veryHighRisk &&
      sumBy(props.medication.statistic.veryHighRisk, (item) => item.count) > 0
    )
      return "veryHighRisk";
    if (
      props.medication.statistic &&
      props.medication.statistic.highRisk &&
      sumBy(props.medication.statistic.highRisk, (item) => item.count) > 0
    )
      return "highRisk";
    if (
      props.medication.statistic &&
      props.medication.statistic.mediumRisk &&
      sumBy(props.medication.statistic.mediumRisk, (item) => item.count) > 0
    )
      return "mediumRisk";
    if (
      props.medication.statistic &&
      props.medication.statistic.lowRisk &&
      sumBy(props.medication.statistic.lowRisk, (item) => item.count) > 0
    )
      return "lowRisk";
    return "showGreenButton";
  });

  const totalRiskCount = computed(() => {
    let count = 0;

    if (!props.medication?.statistic) {
      return count;
    }

    Object.entries(props.medication?.statistic).forEach(([key, risks]) => {
      if (key !== "skipped") {
        risks.forEach((check) => {
          count += check.count;
        });
      }
    });

    return count;
  });

  function openDialog() {
    emit("open:riskScore");
  }
</script>

<template>
  <MedTooltip
    :content="
      mostRiskColor !== 'dontShow'
        ? 'Angezeigt werden die Anzahl der Check-Treffer und die Farbe des höchsten Risikos dieses Arzneimittels.'
        : 'Für diese Arzneimittel wurden keine automatisierten Check-Treffer detektiert.'
    "
  >
    <button
      v-if="mostRiskColor !== 'showGreenButton' && mostRiskColor !== 'dontShowButton'"
      :class="{
        'border-very-high-risk': mostRiskColor === 'veryHighRisk',
        'border-high-risk': mostRiskColor === 'highRisk',
        'border-medium-risk': mostRiskColor === 'mediumRisk',
        'border-low-risk': mostRiskColor === 'lowRisk',
      }"
      class="size-7 cursor-pointer rounded-full border-[3px] bg-white"
      @click="openDialog()"
    >
      <p class="text-sm">{{ totalRiskCount }}</p>
    </button>

    <button
      v-else-if="mostRiskColor === 'showGreenButton'"
      class="size-7 cursor-pointer rounded-full border-[3px] border-mcgreen bg-white"
      @click="openDialog()"
    >
      <p class="text-sm">0</p>
    </button>
  </MedTooltip>
</template>
